import { Box, Code } from "@chakra-ui/react";
import React from "react";
import { ViewWrapper } from "../../../shared/components/ViewWrapper/ViewWrapper";
import { useUserInfo } from "../../../shared/hooks/useUserInfo";

export const WidgetPage = () => {
  const [userInfo] = useUserInfo();

  const snippet = `<script type='text/javascript'>var tellStoryWidgetId = ${
    (userInfo as any)?.tenantId
  };</script>`;

  return (
    <ViewWrapper>
      <Box bg="#011627" color="white" borderRadius={"25px"} p="10">
        <Code colorScheme="#011627" children={snippet}></Code>
        <br />
        <Code
          colorScheme="#011627"
          children="<script defer='defer' src='https://tellstory-widget.web.app/static/js/main.bb993a7a.js'></script>"
        ></Code>
        <br />
        <Code
          colorScheme="#011627"
          children="<link href='https://tellstory-widget.web.app/static/css/main.073c9b0a.css' rel='stylesheet'/>"
        ></Code>
        <br />
        <Code
          colorScheme="#011627"
          children="<div id='tellstory-widget'></div>"
        ></Code>
      </Box>
    </ViewWrapper>
  );
};
